import { Node, Id } from 'NSwag/ServerClient/Client.nswag';

/**
 * Defines actions that can be performed for the
 * Nodes in the store.
 */
export enum NodeActionTypes {
    AddNodes = 'ADD_NODES',
    ModifyNodes = 'MODIFY_NODES',
    DeleteNodes = 'DELETE_NODES'
}

export interface AddNodes {
    type: NodeActionTypes.AddNodes;
    nodes: Node[];
}

export interface ModifyNodes {
    type: NodeActionTypes.ModifyNodes;
    nodes: Node[];
}

export interface DeleteNodes {
    type: NodeActionTypes.DeleteNodes;
    ids: Id[];
}